<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { Breadcrumb,BreadcrumbItem } from 'view-ui-plus';
import bottomFooter from './footer.vue'
import common from '@/common/global.js'
// 使用 ref 定义响应式数据
const keyWord = ref('');
const contentStyle = ref(null);
const imgHeight = ref(90);
// 获取路由相关实例
const route = useRoute();
const router = useRouter();

// 计算属性
const path = computed(() => route.path);
const title = computed(() => {
  let title = route.meta.title;
  if (path.value === '/info') {
    title = route.query.title;
  }
  return title;
});
const companyPath = computed(() => {
  return '/company?id=' + route.query.uniscid;
});
const jgcompanyPath = computed(() => {
  return '/jgcompany?id=' + route.query.uniscid;
});
/* *
 * 跳转首页
 * @description 点击返回首页，跳转至全国公共资源交易平台首页
 * @param {*} 无
 * @return {*} 无
 */
function toHome() {
  // 打开新标签跳转
  common.openUrl('https://www.ggzy.gov.cn/', '_blank');
}
/* *
 * 滚动条跳转到顶部
 * @description 点击返回顶部，滚动条跳转到页面顶部
 * @param {*} 无
 * @return {*} 无
 */
function toPageTop() {
  if (document.documentElement.scrollTop) {
    document.documentElement.scrollTop = 0;
  } else if (document.body.scrollTop) {
    document.body.scrollTop = 0;
  }
}
/* *
 * 搜索
 * @description 点击搜索，根据输入的关键词跳转至搜索结果页
 * @param {*} 无
 * @return {*} 无
 */
function search() {
  if (!keyWord.value.trim()) {
    common.toastMsg('请输入查询关键字')
    return
  }
  const path = route.path
  const obj = {
    path: '/search',
    query: {
      keyWord: keyWord.value,
      time: (new Date()).getTime()
    }
  }
  const objtwo = {
    path: '/jgsearch',
    query: {
      keyWord: keyWord.value,
      time: (new Date()).getTime()
    }
  }
  // analytics.customEvent('companyPer', 'searchIndex')
  if (path === '/search') {
    router.replace(obj)
  } else if (path === '/jgsearch' || path === '/jgcompany' || path === '/jgrank' || path === '/jgproject') {
    router.replace(objtwo)
  } else {
    router.push(obj)
  }
}
</script>
<template>
  <div class="homePage" :class="{ 'home': path === '/home' }">
    <div class="code-wechat" v-drag>
      <div class="wechat-content">
        <div>信息订阅推送，请关注</div>
        <img src="@/assets/imgs/wechat.png" alt="banner" />
        <div>全国公共资源交易<br />
          微信服务号</div>
      </div>
    </div>
    <div class="header-container">
      <!-- 头部内容 -->
      <div class="header">
        <div class="left" @click="toHome">
          <img src="@/assets/imgs/back.png" alt="返回全国公共资源交易平台" />
          全国公共资源交易平台
        </div>
        <div class="right">
          <!-- 搜索框 -->
          <!-- <div class="search-container" v-if="path !== '/home' && path !== '/jghome'"> -->
          <!-- <div class="search-container" v-if="path === '/search' || path === '/jgsearch'"> -->
            <div class="search-container" v-if="path === '/search' || path === '/rank'">
            <div class="input-container">
              <input placeholder="请输入主体名称、统一社会信用代码" v-model="keyWord" @keyup.enter="search">
            </div>
            <div class="btn" @click="search">
              查询
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="banner">
    </div>
    <div class="content" ref="content" :style="contentStyle">
      <Breadcrumb v-if="path !== '/home' && path !== '/jghome'">
        <BreadcrumbItem
          v-if="path === '/search' || path === '/company' || path === '/project' || path === '/aptitude' || path === '/rank' || path === '/credit'"
          to="/home">首页</BreadcrumbItem>
        <BreadcrumbItem
          v-if="path === '/jgsearch' || path === '/jgcompany' || path === '/jgproject' || path === '/jgrank' || path === '/jgcredit'"
          to="/jghome">首页</BreadcrumbItem>
        <BreadcrumbItem v-if="path === '/project' || path === '/aptitude' || path === '/credit'" :to="companyPath">主体详情
        </BreadcrumbItem>
        <BreadcrumbItem v-if="path === '/jgproject' || path === '/jgaptitude' || path === '/jgcredit'"
          :to="jgcompanyPath">主体详情</BreadcrumbItem>
        <block v-if="path === '/table'">
          <BreadcrumbItem to="/home">首页</BreadcrumbItem>
          <BreadcrumbItem :to="companyPath">主体详情</BreadcrumbItem>
        </block>
        <BreadcrumbItem>{{ title }}</BreadcrumbItem>
      </Breadcrumb>
      <router-view></router-view>
    </div>
    <bottom-footer></bottom-footer>
  </div>
</template>

<style lang="scss">
.homePage {
  position: relative;
  // height: 100%;
  min-width: 1200px;
  background-color: #f6f6f6;
  // overflow-y: scroll;

  .code-wechat {
    font-size: 12px;
    position: fixed;
    // margin-right: 20px;
    left: 88%;
    top: 50%;
    transform: translateY(-50%);
    z-index: 800;

    // margin-top: -225px;
    img {
      margin-top: 5px;
      width: 115px;
    }

    .wechat-content {
      padding: 10px;
      background: #2a6dac;
      text-align: center;
      color: #fff;
      border-radius: 4px;
    }
  }

  &.home {
    background-color: #fff;
  }

  .emphasize {
    color: #fd485e;
  }

  .header-container {
    height: 68px;
    background-color: #fff;
    width: 100%;

    .header {
      max-width: 1200px;
      margin: 0 auto;
      line-height: 68px;

      .left {
        display: inline-block;
        color: #09629a;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;

        img {
          margin-right: 15px;
          margin-left: 15px;
          width: 25px;
          height: 25px;
          vertical-align: middle;
        }
      }

      .right {
        float: right;
        margin-right: 15px;

        .phone-wrap {
          position: relative;
          display: inline-block;
          margin-right: 39px;
          font-size: 14px;
          cursor: pointer;

          .phone {
            width: 9.5px;
            margin-right: 7px;
            vertical-align: middle;
            margin-top: -4px;
          }

          .wechat-wrap {
            display: none;
            position: absolute;
            bottom: -186px;
            left: -22px;
            width: 130px;
            text-align: center;

            .bg {
              width: 100%;
            }

            .code {
              position: absolute;
              left: 50%;
              // margin-left: -45px;
              margin-top: 16px;
              transform: translateX(-50%);
              width: 100px;
            }

            .title {
              font-size: 13px;
              line-height: 13px;
              color: #000;
              position: absolute;
              top: 120px;
              left: 50%;
              transform: translateX(-50%);
            }
          }

          &:hover {
            .wechat-wrap {
              display: block;
            }
          }
        }
      }

      .login {
        display: inline-block;
        color: #666;

        span {
          &.line {
            display: inline-block;
            margin: 0 10px;
          }
        }
      }
    }
  }

  // 检索容器
  .search-container {
    margin-right: 38px;
    display: inline-block;
    vertical-align: middle;
    font-size: 0;

    >div {
      display: inline-block;
      font-size: 16px;
      vertical-align: middle;
    }

    .input-container {
      display: inline-block;
    }

    input {
      font-size: 16px;
      height: 45px;
      line-height: 45px;
      border: 1px solid #77a7c3;
      padding: 0 20px;
      width: 320px;
      background-color: #eeeeee;
      color: #181818;

      &:focus {
        outline: none;
      }

      &::-webkit-input-placeholder {
        color: #aaaaaa;
      }

      border-radius: 5px 0px 0px 5px;
    }

    .btn {
      width: 80px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 16px;
      background: #77a7c3;
      border-radius: 0px 5px 5px 0px;
      color: #fff;
      cursor: pointer;
    }
  }

  .banner {
    width: 100%;
    height: 140px;
    overflow: hidden;
    text-align: center;
    background: #09629a;
    background-image: url("@/assets/imgs/banner.png");
    background-size: auto 174px;
    background-position: center bottom;

    .wechat {
      width: 100%;
      max-width: 1200px;
      text-align: right;
      margin: 0 auto;
      color: #fff;

      .wechat-content {
        display: inline-block;
        text-align: center;
        font-size: 12px;
        color: #fff;
        margin-top: 7px;
      }

      img {
        height: 80px;
        margin-top: 6px;
      }
    }
  }

  .content {
    width: 100%;
    max-width: 1200px;
    min-height: calc(100vh - 394px);
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;

    .ivu-breadcrumb {
      padding-bottom: 15px;
      background: #f6f6f6;
    }

    .some-info {
      width: 100%;
      margin-top: 10px;
      font-size: 14px;
      line-height: 14px;
      color: #333333;

      .label {
        color: #808b9f;
      }
    }
  }
}
</style>